import { useState } from 'react';

import TopBar from '../components/TopBar';
import { useStore } from '../store';

export default function ExpressionListScreen() {
  const s = useStore();
  const lesson = s.currentLesson;
  const [revealed, setRevealed] = useState<Record<number, boolean>>({});

  if (!lesson) return null;

  return (
    <div className="screen">
      <TopBar
        title={s.t('mode.expression_list.title')}
        subtitle={lesson.unit.trim()}
        onBack={s.backToScenarioMenu}
        backLabel={s.t('nav.back')}
      />
      <div className="scroll">
        <ul className="list">
          {lesson.items.map((item, index) => {
            const showKor = !!revealed[index];
            return (
              <li key={index} className="expr-card">
                <div className="expr-card__text">
                  <div className="expr-card__eng">{item.eng_text}</div>
                  {showKor && !!item.kor_text && <div className="expr-card__kor">{item.kor_text}</div>}
                </div>
                <button
                  type="button"
                  className="icon-btn"
                  onClick={() => s.playItemAudio(index)}
                  aria-label={`${s.t('dictation.replay_button')}: ${item.eng_text}`}
                >
                  🔊
                </button>
                <button
                  type="button"
                  className="icon-btn"
                  onClick={() => setRevealed((r) => ({ ...r, [index]: !r[index] }))}
                  aria-pressed={showKor}
                  aria-label={showKor ? s.t('dictation.hide_meaning') : s.t('dictation.show_meaning')}
                >
                  <span className={`checkbox${showKor ? ' is-on' : ''}`} aria-hidden="true">
                    ✓
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
